function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.875 2.5C5.84717 2.5 5 3.34717 5 4.375V15.625C5 16.6528 5.84717 17.5 6.875 17.5H13.125C14.1528 17.5 15 16.6528 15 15.625V4.375C15 3.34717 14.1528 2.5 13.125 2.5H6.875ZM6.875 3.75H13.125C13.4717 3.75 13.75 4.02832 13.75 4.375V15.625C13.75 15.9717 13.4717 16.25 13.125 16.25H6.875C6.52832 16.25 6.25 15.9717 6.25 15.625V4.375C6.25 4.02832 6.52832 3.75 6.875 3.75ZM10 14.375C9.65576 14.375 9.375 14.6558 9.375 15C9.375 15.3442 9.65576 15.625 10 15.625C10.3442 15.625 10.625 15.3442 10.625 15C10.625 14.6558 10.3442 14.375 10 14.375Z",
  fill: "white"
});
function SvgIconIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIphone);
export default __webpack_public_path__ + "static/media/iconIphone.5415415f.svg";
export { ForwardRef as ReactComponent };